import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { GenerateThink5whysCode } from '../components/GenerateThink5whysCode';
import "../styles/Think5WhysCode.css";
import { logout } from "../redux/actions/authActions";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("Home");
  const [activeSubTab, setActiveSubTab] = useState(null);
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";
  const [selectedFutureModule, setSelectedFutureModule] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ctaRef = useRef(null);
  const mainRef = useRef(null);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  const testCode = GenerateThink5whysCode(); 

  const handleTabClick = (tab) => {
    setActiveTab(tab.name);
    setActiveSubTab(null);

    if (tab.tLink !== "buttons") {
      navigate(tab.tLink); 
    }
  };

  const handleSubTabClick = (sub) => {
    setActiveSubTab(sub.name);
    if (sub.bLink) {
      navigate(sub.bLink);
    }
  };

 const tabs = [
  // { name: "Home", icon: "fa-home", emoji: "🏠", tLink: "buttons" },
  { name: "PurpleDoor", icon: "fa-home", emoji: "🟣", tLink: "/purpledoor" },
  { name: "Profile", icon: "fa-user", emoji: "👤", tLink: "/my-profile-home" },
  { name: "DigiBoutique", icon: "fa-user", emoji: "🛍️", tLink: "/digiboutique" },
  { name: "Wallet", icon: "fa-wallet", emoji: "👛", tLink: "/wallet-home" },
  { name: "DigiIncome", icon: "fa-coins", emoji: "💰", tLink: "buttons" },
  { name: "SAKSHAM-Bharat", icon: "fa-hand-holding-heart", emoji: "💪", tLink: "/sakshambharat" },
  { name: "LnD", icon: "fa-book-open", emoji: "📖", tLink: "/lnd" },
  { name: "SHEETAL-Gov", icon: "fa-water", emoji: "💧", tLink: "/sheetal" },
  { name: "AICounselling", icon: "fa-brain", emoji: "🤖", tLink: "/aicounselling" },
  { name: "OneView", icon: "fa-eye", emoji: "👁️", tLink: "/oneviewdashboard" },
  { name: "Marketplace", icon: "fa-store", emoji: "🛍️", tLink: "buttons" },
  { name: "MetaVerse", icon: "fa-vr-cardboard", emoji: "🌐", tLink: "buttons" },
  { name: "Rankings", icon: "fa-trophy-circle", emoji: "🏆", tLink: "/rankings" },
  { name: "Games", icon: "fa-gamepad", emoji: "🎮", tLink: "buttons" },
  { name: "Admin", icon: "fa-user-shield", emoji: "🛡️", tLink: "/admindashboard" },
  { name: "About", icon: "fa-info-circle", emoji: "ℹ️", tLink: "buttons" },
  { name: "DigitalTwins", icon: "fa-robot", emoji: "🧬", tLink: "/twiworld" }, 
  { name: "Thinky", icon: "fa-brain", emoji: "🧠", tLink: "/agenticsim" },  

];

const subTabs = {
  Home: [],
  Profile: [
    { name: "My Details", emoji: "👤", bLink: "/profile/details" },
    { name: "ID & KYC", emoji: "🪪", bLink: "/profile/kyc" },
    { name: "Security", emoji: "🔐", bLink: "/profile/security" },
  ],
  DigiIncome: [
    { name: "Calculator", emoji: "💵", bLink: "/orderflow-earning-estimator" },
    // { name: "Digital Boutique", emoji: "🛍️", bLink: "/digiboutique" },
    { name: "Photo Can Win", emoji: "👥", bLink: "/photocanwin" },
    { name: "Kharcho Jeeto", emoji: "🎁", bLink: "/kharchojeeto" },
    { name: "Marksheet Contest", emoji: "📜", bLink: "/applause-marksheet-contest" },
    { name: "Rewarding Ads", emoji: "💎", bLink: "/visigift-home" },
    { name: "Rewarding Videos", emoji: "🎥💰", bLink: "/orderflow-spotbuy" },
    { name: "Aalu Daalo Sona Nikalo", emoji: "🥔✨", bLink: "" },
    { name: "Business Funding", emoji: "💳", bLink: "/fundlanes" },
  ],
  Marketplace: [
    { name: "Digital", emoji: "🛒", bLink: "/marketplace/digital" },
    { name: "Products", emoji: "📦", bLink: "/marketplace/products" },
    { name: "Services", emoji: "⭐", bLink: "/marketplace/services" },
    { name: "Rental", emoji: "🏠", bLink: "/marketplace/rental" },
    { name: "Wholesale", emoji: "📦", bLink: "/marketplace/wholesale" },
    { name: "Nearby", emoji: "📍", bLink: "/marketplace/nearby" },
    { name: "Unity", emoji: "🤝", bLink: "/marketplace/unity" },
  ],
  MetaVerse: [
    { name: "Agri", emoji: "🌐", bLink: "/agrilink-metaverse" },
    { name: "Manufacturing", emoji: "🎭", bLink: "/syntramfg-metaverse" },
    { name: "MSME", emoji: "🏗️", bLink: "/msme" },
    { name: "Education", emoji: "🏗️", bLink: "/bookworld" },
  ],
  About: [
    { name: "Mission", emoji: "🌍", bLink: "/about-us" },
    { name: "Team", emoji: "👥", bLink: "/about-us" },
    { name: "Contact", emoji: "📞", bLink: "/contact-us" },
  ],

  Games: [
    { name: "Farmers Games", emoji: "🌾🎯", bLink: "/agrilink-games" },        
    { name: "MSME Games", emoji: "🏢💰", bLink: "/msme-games" },          
    { name: "Manufacturing Games", emoji: "🏭⚙️", bLink: "" }, 
    { name: "Cooking Games", emoji: "🍳👩‍🍳", bLink: "" },      
    { name: "Shaksham Shakti Games", emoji: "💪🏆", bLink: "/sheearns-games" },
    { name: "Teacher's Games", emoji: "📚👩‍🏫", bLink: "" },   
    { name: "Corporate Games", emoji: "💼🏢", bLink: "" },     
  ],
};

useEffect(() => {
  if (selectedFutureModule && ctaRef.current) {
    ctaRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, [selectedFutureModule]);

return (
    <div className="min-h-screen flex flex-col bg-black text-[#E6F4F1] font-inter">
      <header className="sticky top-0 z-50 bg-gradient-to-br from-[#001F1F] to-[rgb(3,73,73)] text-[#E6F4F1] shadow-md px-2 py-2 flex flex-row justify-between items-center">
        <div className="flex flex-col justify-start">
          <h1 className="text-sm lg:text-lg font-bold text-yellow-200">
            🌐 Think5Whys Transformation-as-a-Platform
          </h1>
          <h2 className="px-2 text-sm lg:text-lg font-bold text-yellow-200">
            Ecosystem Dashboard
          </h2>
        </div>

        {isLoggedIn ? (
          <div className="flex flex-col items-end">
            <button
              onClick={handleLogout}
              className="rounded-md bg-rose-600 hover:bg-rose-700 transition flex items-center justify-center"
              title="Logout"
            >
              ⏻
            </button>
            <p className="text-[9px] lg:text-xs text-gray-200">{userName}</p>
          </div>
        ) : (
          <button
            onClick={() => navigate("/login")}
            className="rounded-full border border-pink-700 text-sm text-pink-200 hover:bg-pink-900 transition mt-1"
          >
            🔑
          </button>
        )}
      </header>

      <main ref={mainRef} className="flex flex-col justify-center items-center text-center min-h-[60vh] p-2">
        <div className="flex flex-col gap-0.5 space-y-0.5"> 
          {tabs
            .filter((tab) => tab.name === "PurpleDoor")
            .map((tab) => (
              <button
                key={tab.name}
                onClick={() => handleTabClick(tab)}
                className={`
                  w-full
                  flex gap-2
                  py-3
                  rounded-md
                  border border-purple-500
                  bg-gradient-to-r from-purple-900 via-purple-700 to-purple-900
                  text-white
                  shadow-md
                  hover:scale-[1.01]
                  transition-all duration-300
                `}
              >
                

                <div className="flex-1 flex-col text-center justify-center items-center">
                  <div className="font-semibold text-[12px] lg:text-lg">
                    <span className="text-lg lg:text-xl">{tab.emoji}</span> PurpleDoor BOS & Human Transformation Platform 
                  </div>

                  <div className="text-[9px] sm:text-xs text-purple-100">
                    Purposeful Digital Engagement & Digital Entrepreneurship
                  </div>
                </div>
              </button>
            ))}

          {/* Other Modules */}
          <div
            className="
              grid
              grid-cols-3
              lg:grid-cols-6
              rounded-md
              overflow-hidden
              text-[10px]
              lg:text-sm
              place-items-center
            "
          >
            {tabs
              .filter((tab) => tab.name !== "PurpleDoor")
              .map((tab) => (
                <button
                  key={tab.name}
                  onClick={() => {setSelectedFutureModule(tab.name);}}
                  className="
                    flex flex-col
                    items-center
                    justify-center
                    w-full
                    py-1 
                    border border-[#003E3E]
                    bg-black
                    text-[#C4EAE8]
                    opacity-80
                    cursor-pointer hover:bg-[#002828]
                  "
                >
                  <span className="text-sm lg:text-m mb-1 text-white">
                    {tab.emoji}
                  </span>

                  <span className="text-[10px] lg:text-sm text-center text-white">
                    {tab.name}
                  </span>

                  <span className="text-[9px] text-yellow-300 mt-1">
                    Unlock
                  </span>
                </button>
              ))}
          </div>
          {selectedFutureModule && (
            <div
              ref={ctaRef}
              className="
                mt-4
                bg-gradient-to-r
                from-[#002828]
                to-[#014848]
                border
                border-teal-600
                rounded-xl
                p-4
                shadow-lg
                animate-fadeIn
              "
            >
              <h3 className="text-yellow-200 font-bold text-lg mb-2">
                🚀 {selectedFutureModule} being offered Live 
              </h3>

              <p className="text-xs lg:text-sm text-[#C4EAE8] leading-relaxed">
                <strong className="text-xs lg:text-sm">{selectedFutureModule}</strong> is part of the Think5Whys
                Transformation Ecosystem, a human-development framework designed to unlock
                potential at scale. The ecosystem is anchored on eight strategic pillars:
                MSMEs, Women, Youth, Government, Blue-Collar Workers, Farmers & Rural
                Economy, Learning & Development (Teachers and Students), and Early
                Childhood Development through support for mothers of preschool children.
              </p>

              <p className="mt-2 text-xs lg:text-sm text-[#C4EAE8] leading-relaxed">
                Designed for the world's 6+ billion potential users, MSMEs,
                enterprises, educational institutions, government bodies,
                armed forces, railways, healthcare systems, and community
                organizations seeking measurable human growth and performance.
              </p>

              <p className="mt-2 text-sm text-[#C4EAE8] leading-relaxed">
                Access to this capability is currently being coordinated
                through our global transformation network.
              </p>

              <div className="flex flex-row gap-2 mt-2">
                <button
                  onClick={() => navigate("/coordinators")}
                  className="
                    bg-yellow-500
                    hover:bg-yellow-400
                    text-black
                    text-xs lg:text-sm
                    font-semibold
                    px-2
                    py-1
                    rounded-lg
                    transition-all
                    w-3/4
                  "
                >
                  🌍 Contact Global Coordinators
                </button>

                <button
                  onClick={() => setSelectedFutureModule(null)}
                  className="
                    bg-[#003E3E]
                    hover:bg-[#005C5C]
                    text-white
                    px-2
                    py-1
                    text-xs lg:text-sm
                    rounded-lg
                    w-1/2
                  "
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-center items-center text-center mt-2 mb-2 p-4">
          {activeTab === "Home" ? (
            <div className="mt-1 bg-gradient-to-br from-[#001F1F] to-[rgb(13,124,124)] text-[#E6F4F1] rounded-xl p-4 shadow-lg border border-teal-800 text-sm lg:text-lg min-w-[400px] max-w-2xl">
              <h3 className="text-sm lg:text-lg font-semibold mb-3 text-yellow-200 flex items-center justify-center gap-2">
                <i className="fas fa-user-circle text-teal-400 text-sm lg:text-lg"></i>
                Think5Whys Identity
              </h3>

              <div className="space-y-2 text-center">
                <p>
                  <span className="font-semibold text-xs lg:text-sm text-teal-300">Think5Whys Code:</span>{" "}
                  <span className="text-yellow-100 text-xs lg:text-sm">
                    {authState?.user?.think5whyscode || "N/A"}
                  </span>
                </p>

                <p className="text-[#A7DAD8] text-xs lg:text-sm">
                  {authState?.user?.name || "N/A"}
                </p>

                <p className="text-xs lg:text-sm text-gray-300 italic">
                  {authState?.user?.email || "N/A"}
                </p>

                <p>
                  <span className="text-xs lg:text-sm font-semibold text-teal-300">User Since:</span>{" "}
                  <span className="text-yellow-100 text-xs lg:text-sm">
                    {authState?.user?.createdAt
                      ? formatDate(new Date(authState.user.createdAt))
                      : "N/A"}
                  </span>
                </p>
              </div>
            </div>

          ) : tabs.find((t) => t.name === activeTab)?.tLink === "buttons" ? (
            <div className="mt-2">
              <h2 className="text-xs lg:text-sm font-semibold rounded-lg mb-2 flex justify-center items-center gap-2 bg-teal-800 text-white py-1">
                <i
                  className={`fas ${
                    tabs.find((t) => t.name === activeTab)?.icon
                  } text-xs lg:text-sm`}
                ></i>
                {activeTab}
              </h2>

              <div
                className="
                  grid grid-cols-3 lg:grid-cols-6
                  gap-2 rounded-md overflow-hidden text-[11px]
                  place-items-center
                "
              >
                {subTabs[activeTab]?.map((sub) => (
                  <button
                    key={sub.name}
                    onClick={() => handleSubTabClick(sub)}
                    className={`p-3 text-xs lg:text-sm font-medium text-center leading-tight transition-all duration-300 border border-[#003E3E]
                      ${
                        activeSubTab === sub.name
                          ? "bg-[#002828] text-yellow-200 shadow-inner"
                          : "bg-[#001F1F] text-[#C4EAE8] hover:bg-[#005C5C]"
                      }`}
                    style={{ wordWrap: "break-word", whiteSpace: "normal" }}
                  >
                    <p className="text-white mr-1 text-xs lg:text-sm">{sub.emoji}</p>
                    <p className="text-white text-xs lg:text-sm">{sub.name}</p>
                  </button>
                ))}
              </div>


              {activeSubTab && (
                <div className="mt-2 text-center bg-[#003E3E] rounded-2xl p-4 border border-[#006666]">
                  <p className="text-sm">
                    🧭 <strong>{activeSubTab}</strong> content will appear here soon.
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div className="mt-2">
              <h2 className="text-sm lg:text-lg font-semibold mb-2">👋 Welcome to Think5Whys Dashboard</h2>
              <p className="text-xs lg:text-sm text-[#BFE7E4]">
                Your personalized transformation space. (You can customize this later)
              </p>
            </div>
          )}
        </div>
      </main>

      <footer className="bg-gradient-to-br from-[#001F1F] to-[rgb(73,231,231)] border-t border-blue-800 text-white py-4">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">
            © {new Date().getFullYear()} Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-200">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-200">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-200">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-200">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;
